import React from 'react';

import { isNumber } from 'lodash-es';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import {
  PointsNeededContainer,
  PointsNeededDescription,
  PointsNeededLockIcon,
  PointsNeededText,
  StyledPointsIcon,
  StyledProgressMeter,
} from './loyalty-rewards.styled';
import { MeterContainer, RewardCategoryMeterContainer } from './loyalty-rewards.styled';
import { ILoyaltyRewardsMeter } from './types';

export const LoyaltyRewardsMeter: React.FC<ILoyaltyRewardsMeter> = ({
  redemptionPercentage,
  remainingPointsNeededForRedemption,
}) => {
  return (
    <RewardCategoryMeterContainer>
      {isNumber(redemptionPercentage) && (
        <MeterContainer>
          <PointsNeededLockIcon />
          <StyledProgressMeter
            percentage={redemptionPercentage}
            _progress={{ background: primitive.bk.$meltyYellow }}
          />
        </MeterContainer>
      )}
      {remainingPointsNeededForRedemption && (
        <PointsNeededContainer>
          <StyledPointsIcon></StyledPointsIcon>
          <PointsNeededText>{remainingPointsNeededForRedemption}</PointsNeededText>
          <PointsNeededDescription>
            {t('crownsAwayFromUnlockingMoreRewards')}
          </PointsNeededDescription>
        </PointsNeededContainer>
      )}
    </RewardCategoryMeterContainer>
  );
};
